import React from 'react';
import styled from 'styled-components';
import { compose } from 'redux';
import { globalTheme } from '@clds/component-theme';
import { asStyledComponent } from '@clds/component-enhancer';
import { IfWizard } from 'components/featureFlags/layoutStyle';
import { IfCloseButton, IfTitle } from 'components/featureFlags/mode';
import { IfLogo } from 'components/featureFlags/isLogo';

const StyledHeader = styled.div`
  background-color: ${globalTheme.palette.surface};
  display: flex;
  align-items: center;
  z-index: 1;
  padding: ${globalTheme.spacing.xs} ${globalTheme.spacing.md};
  border-bottom: 1px solid ${globalTheme.palette.backgroundAlt};
  min-height: 55px;
  justify-content: space-between;

  > *:only-child {
    display: flex;
    margin: 0 auto;
    align-items: center;
  }
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Header = () => {
  return (
    <StyledHeader data-test="widget-header">
      <Wrapper>
        <IfLogo />
        <IfTitle />
      </Wrapper>
      <IfWizard />
      <IfCloseButton />
    </StyledHeader>
  );
};

export default compose(asStyledComponent)(Header);
